import { Modal } from 'bootstrap';
import { Input } from 'mdb-ui-kit';

let ticket_transfer = document.querySelectorAll('.transfer_ticket');

class Conference_Ticket_Transfer {

    constructor( buttons ){

        this.buttons = buttons
        this.modalopen = false;
        this.form_submitting = false;

        this.setup();

    }

    setup(){

        let self = this;

        for (var i = 0; i < this.buttons.length; i++) {

            this.buttons[i].onclick = function( e ) {

                self.transferModal( e );

            }

        }

    }

    transferModal( event ){

        // Build Modal with transfer ability. 
        let ticket = event.target;
        let ticket_id = ticket.getAttribute('data-ticket');

        this.generateModal( ticket_id, event );

    }

    makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
        }
        return result;
    }


    generateModal( ticket_id, event ){


        if( this.modalopen ){
            return;
        }

        let target = event.target;

        let self = this;
        this.modalopen = true;
        
            let modal_id = this.makeid(5);

            const modal = document.createElement("div");
            modal.classList.add('modal', 'fade', 'modal-ticket-transfer');
            modal.setAttribute('id', modal_id );
            modal.setAttribute('tabindex', '-1');
            modal.setAttribute('aria-labelledby', modal_id + 'Label');
            modal.setAttribute('aria-hidden', 'true');

            const modal_dialog = document.createElement("div");
                    modal_dialog.classList.add('modal-dialog', 'modal-dialog-centered');

                    const modal_content = document.createElement("div");
                        modal_content.classList.add('modal-content');

                        const modal_header = document.createElement("div");
                            modal_header.classList.add('modal-header');

                                const modal_title = document.createElement("h2");
                                    modal_title.classList.add('modal-title');

                                    // const modal_title_text = document.createTextNode("Register your interest");
                                    const modal_title_text = document.createTextNode("Transfer Ticket");
                                    modal_title.appendChild(modal_title_text);
            

                                modal_header.append( modal_title );   


                                const modal_body = document.createElement("div");
                                modal_body.classList.add('modal-body');


                                    // Add in content 

                                    const modal_intro = document.createElement("div");
                                    modal_intro.classList.add('modal-intro');

                                    modal_intro.innerHTML = JSON.parse( theme.transfer_modal_text );


                                    modal_body.append( modal_intro );   


                                    const form_div = document.createElement("form");
                                    form_div.setAttribute('novalidate', 'novalidate');
                                    form_div.classList.add('needs-validation', 'g-3');
                        
                                    const div_error_messages = document.createElement("div");
                                    div_error_messages.classList.add('error-messages');
                                
                                        form_div.append( div_error_messages );  // Append the error messages to the form.
                                

                                        // Create Input
                                        const input_ticket_id = document.createElement("input");
                                            input_ticket_id.setAttribute('type', 'hidden');
                                            input_ticket_id.setAttribute('id', 'ticket_id');
                                            input_ticket_id.setAttribute('name', 'ticket_id');
                                            input_ticket_id.setAttribute('value',  ticket_id);
                            
                                            form_div.appendChild(input_ticket_id);

                            
                                        // Need to add in First Name 
                                        const div_first_name = document.createElement("div");
                                        div_first_name.classList.add('form-outline', 'mb-4');
                                
                                            // Create Input
                                            const input_first_name = document.createElement("input");
                                                input_first_name.classList.add('form-control', 'form-control-lg' );
                                                input_first_name.setAttribute('type', 'text');
                                                input_first_name.setAttribute('id', 'first_name');
                                                input_first_name.setAttribute('name', 'first_name');
                                                input_first_name.setAttribute('autocomplete', 'off');
                                                input_first_name.setAttribute('required', 'required');
                                
                                            div_first_name.appendChild(input_first_name);
                                
                                            // Create Label
                                            const label_first_name = document.createElement("label");
                                                label_first_name.classList.add('form-label');
                                                label_first_name.setAttribute('for', 'first_name');
                                
                                                const label_first_name_text = document.createTextNode("First Name");
                                                label_first_name.appendChild(label_first_name_text);
                                            
                                            div_first_name.appendChild(label_first_name);
                                
                                
                                            // Create Error Label
                                            const validation_error_first_name = document.createElement("div");
                                                validation_error_first_name.classList.add('invalid-feedback');
                                
                                                const validation_error_first_name_text = document.createTextNode("You must provide their first name");
                                                validation_error_first_name.appendChild(validation_error_first_name_text);
                                
                                            div_first_name.appendChild(validation_error_first_name);
                                
                                        // Last Name
                                        const div_last_name = document.createElement("div");
                                        div_last_name.classList.add('form-outline', 'mb-4');
                                
                                            // Create Input
                                            const input_last_name = document.createElement("input");
                                                input_last_name.classList.add('form-control', 'form-control-lg' );
                                                input_last_name.setAttribute('type', 'text');
                                                input_last_name.setAttribute('id', 'last_name');
                                                input_last_name.setAttribute('name', 'last_name');
                                                input_last_name.setAttribute('autocomplete', 'off');
                                                input_last_name.setAttribute('required', 'required');
                                
                                            div_last_name.appendChild(input_last_name);
                                
                                            // Create Label
                                            const label_last_name = document.createElement("label");
                                                label_last_name.classList.add('form-label');
                                                label_last_name.setAttribute('for', 'last_name');
                                
                                                const label_last_name_text = document.createTextNode("Last Name");
                                                label_last_name.appendChild(label_last_name_text);
                                            
                                            div_last_name.appendChild(label_last_name);
                                
                                
                                            // Create Error Label
                                            const validation_error_last_name = document.createElement("div");
                                                validation_error_last_name.classList.add('invalid-feedback');
                                
                                                const validation_error_last_name_text = document.createTextNode("You must provide their last name");
                                                validation_error_last_name.appendChild(validation_error_last_name_text);
                                
                                            div_last_name.appendChild(validation_error_last_name);
                                
                                
                                        // Email Address 
                                        const div_email_address = document.createElement("div");
                                        div_email_address.classList.add('form-outline', 'mb-4');
                                
                                            // Create Input
                                            const input_email_address = document.createElement("input");
                                                input_email_address.classList.add('form-control', 'form-control-lg' );
                                                input_email_address.setAttribute('type', 'email');
                                                input_email_address.setAttribute('id', 'email_address');
                                                input_email_address.setAttribute('name', 'email_address');
                                                input_email_address.setAttribute('autocomplete', 'off');
                                                input_email_address.setAttribute('required', 'required');
                                
                                            div_email_address.appendChild(input_email_address);
                                
                                            // Create Email Label
                                            const label_email_address = document.createElement("label");
                                                label_email_address.classList.add('form-label');
                                                label_email_address.setAttribute('for', 'email_address');
                                
                                                const label_email_address_text = document.createTextNode("Email Address");
                                                label_email_address.appendChild(label_email_address_text);
                                            
                                            div_email_address.appendChild(label_email_address);
                                
                                
                                            // Create Email Error Label
                                            const validation_error_email_address = document.createElement("div");
                                                validation_error_email_address.classList.add('invalid-feedback');
                                
                                                const validation_error_email_address_text = document.createTextNode("You must provide a valid email address");
                                                validation_error_email_address.appendChild(validation_error_email_address_text);
                                
                                            div_email_address.appendChild(validation_error_email_address);
                                
                                        // Confirm 
                                        const div_email_consent = document.createElement("div");
                                        div_email_consent.classList.add('form-check', 'mb-4');

                                            // Create Email
                                            const input_email_consent = document.createElement("input");
                                                input_email_consent.classList.add('form-check-input' );
                                                input_email_consent.setAttribute('type', 'checkbox');
                                                input_email_consent.setAttribute('id', 'email_consent');
                                                input_email_consent.setAttribute('name', 'email_consent');
                                                input_email_consent.setAttribute('required', 'required');
                                                input_email_consent.setAttribute('value', '1');
                            
                                            div_email_consent.appendChild(input_email_consent);
                                            
                                            // Create Email Label
                                            const label_email_consent = document.createElement("label");
                                                label_email_consent.classList.add('form-check-label');
                                                label_email_consent.setAttribute('for', 'email_consent');
                            
                                                const label_email_consent_text = document.createTextNode("I confirm the details above are correct");
                                                label_email_consent.appendChild(label_email_consent_text);
                                            
                                            div_email_consent.appendChild(label_email_consent);
                        

                                        
                                        // Create Submit Button
                                        const div_submit = document.createElement("div");
                                            div_submit.classList.add('d-grid', 'gap-2');

                                        const button_submit = document.createElement("button");
                                            button_submit.setAttribute('type', 'submit');
                                            button_submit.classList.add('btn', 'btn-lg', 'btn-secondary', 'transfer-btn');

                                            const button_span_submit = document.createElement("span");
                                            button_span_submit.setAttribute('role', 'status');
                                            button_span_submit.setAttribute('aria-hidden', 'true');

                                            button_submit.appendChild(button_span_submit);

                                            // const button_submit_text = document.createTextNode("Submit");
                                            const button_submit_text = document.createTextNode("Transfer");
                                            button_submit.appendChild(button_submit_text);



                                            div_submit.appendChild(button_submit);
                           
                                
                                        // Attach Fields 
                                        form_div.appendChild(div_first_name);
                                        form_div.appendChild(div_last_name);
                                        form_div.appendChild(div_email_address);
                                        form_div.appendChild(div_email_consent);
                                        form_div.appendChild(div_submit);
                                        
                            
                                    modal_body.append( form_div );   


                                const modal_close= document.createElement("button");
                                    modal_close.classList.add('btn-close');
                                    modal_close.setAttribute('type', 'button');
                                    modal_close.setAttribute('data-bs-dismiss', 'modal');
                                    modal_close.setAttribute('aria-label', 'Close');

                                    const modal_close_icon = document.createElement("i");
                                    modal_close_icon.classList.add('fal');
                                    modal_close_icon.classList.add('fa-times-circle');
                                    modal_close_icon.classList.add('close-icon');
                                    modal_close.append( modal_close_icon );   

                                    
                                
                                modal_header.append( modal_close );   


                        modal_content.append( modal_header );   
                        modal_content.append( modal_body );  

                        modal_dialog.append( modal_content );   


                    modal.append( modal_dialog );   



        document.body.append( modal );    

        // Open the Modal 
        let modal_js = new Modal( document.getElementById( modal_id  ), {  backdrop : false } );


        self.initInputs();


        modal_js.show();

        // Remove the Modal if shut
        document.getElementById( modal_id  ).addEventListener('hidden.bs.modal', function (event) {

            document.getElementById( modal_id ).remove();
            self.modalopen = false;

        });

        // On show re-init inputs
        document.getElementById( modal_id  ).addEventListener('shown.bs.modal', function (event) {

        //   self.initInputs();
        
        });

        div_submit.onclick = function( event ){

            event.preventDefault();
            event.stopPropagation();

            form_div.requestSubmit();


        }


        // On submit the form
        form_div.onsubmit = function( event ){
                                        
            event.preventDefault();
            event.stopPropagation();

            const alert_area = document.getElementById('account-alerts');

            self.form_submitting = true;

            if ( form_div.checkValidity() ) {

                // Send the data to wordpress.

                grecaptcha.ready(function() {

                    grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {

                        var form_data = new FormData( form_div );
                        form_data.append( 'token', token);
                        form_data.append( 'action', 'ticket_transfer');

                        jQuery.ajax({
                            type: 'POST',
                            contentType: false,
                            processData: false,
                            url: theme.ajax,
                            data: form_data,
                        
                            
                            beforeSend : function(){

                                // // Clear the error messages
                                // if( div_error_messages.firstChild ){
                                //     while(div_error_messages.firstChild && div_error_messages.removeChild(div_error_messages.firstChild));
                                // }

                                // // Set button to spinner         
                                // button_submit.removeChild(button_submit_text);
                                // button_submit.setAttribute('disabled', 'disabled');
                                
                                // button_span_submit.classList.add('spinner-border', 'spinner-border-sm'); ///

                            },
                            
                            success: function( response ){

                                response = JSON.parse( response );

                                if( response.success ){

                                    if( alert_area ){
            
                                        let alert_div = document.createElement('div');
                                        alert_div.classList.add('alert', 'alert-success' );
                                        alert_div.setAttribute( 'role', 'alert');
                
                                        alert_div.innerHTML = response.success_message;
                
                                        alert_area.append( alert_div );

                                    }

                                    if( target ){

                                        target.setAttribute('disabled',true);
                                        target.innerText = "Ticket Transfer Unavailable";
                                        
                                    }

                                    // Now change buttons and remove the ticket.

                                    let ticket_table = document.getElementById('td-' + ticket_id );
                                    if( ticket_table ){

                                        let table_name = ticket_table.querySelector('.name');
                                        let table_email = ticket_table.querySelector('.email');

                                        table_name.innerText = input_first_name.value + " " + input_last_name.value;
                                        table_email.innerText = input_email_address.value;

                                    }   


                                    let ticketDetails = document.querySelector('.tickets_wrapper');

                                    if( ticketDetails ){

                                        ticketDetails.remove();

                                        let fields = document.querySelectorAll('.tickets_wrapper .form-control, .tickets_wrapper .acf-button');

                                        if( fields ){

                                            for (var i = 0; i < fields.length; i++) {
    
                                              fields[i].setAttribute('disabled', 'disable');
                                              fields[i].classList.add('disabled');
                                        
                                            }
                                            
                                        

                                        }
                            
                                    }

                                    let ticketCol = document.querySelectorAll('.col-ticket');

                                    if( ticketCol ){

                                        for (var i = 0; i < ticketCol.length; i++) {
    
                                            ticketCol[i].remove();
                                      
                                        }

                                    }

                                    button_submit.remove();

                                    modal_js.hide();
                                    
                                    if( ! ticketDetails ){

                                    location.reload();

                                    }
            
                                } else {
            
                                    let alert_div = document.createElement('div');
                                    alert_div.classList.add('alert', 'alert-error' );
                                    alert_div.setAttribute( 'role', 'alert');
            
                                    alert_div.innerHTML = response.error_message;
            
                                    alert_area.append( alert_div );
            
                                }
            
                                button_submit.removeAttribute('disabled');
                                

                            }

                        });
                        
                    });

                  });


            }

            form_div.classList.add('was-validated');


        }



    }


    initInputs(){

        document.querySelectorAll('.form-outline').forEach((input) => {
    
            new Input( input ).init();
    
        });  
    }


}



window.addEventListener("load", function(){
    
    if( ticket_transfer.length ){


        const class_ticket_transfer = new Conference_Ticket_Transfer( ticket_transfer );
     
     
     }

});